import { sv } from "@dhx/ts-common/dom";
import { calcPointRef } from "../helpers/common";
import { ISeriaConfig, PointData, SvgElement } from "../types";
import ScaleSeria from "./ScaleSeria";

export default class Line extends ScaleSeria {
	paint(width: number, height: number): SvgElement {
		super.paint(width, height);

		const color = this.config.pointColor || this.config.color;
		const css = `chart ${this.config.type} ${this.config.css || ""} ${this.config.dashed ? "dash-line" : ""}`;

		let svg = [];
		if (this.config.strokeWidth){
			svg.push(
				this._getForm(this._points as any, this.config, css, width, height)
			);
		}

		if (this.config.pointType) {
			const point = this._getPointType(this.config.pointType, color, false);
			svg = svg.concat(this._points.map(p => point(p[0], p[1], calcPointRef(p[2], this.id))));
		}

		return sv("g", {class: "seria", _key: this.id}, svg);
	}
	protected _getForm(points: PointData[], config:any, css:string, width: number, height: number): object {
		const d = points.map((item, index) => (index ? "L" : "M") + `${item[0]} ${item[1]}`).join(" ");
		const path = sv("path", {
			"id": "seria" + config.id,
			d,
			"stroke": config.color,
			"class": css,
			"stroke-width": this.config.strokeWidth,
			"fill": "none"
		});
		return path;
	}
	protected _setDefaults(config: ISeriaConfig) {
		const defaults = {
			alpha: 1,
			strokeWidth:2,
			active: true,
			tooltip: true
		};
		this.config = {...defaults, ...config};
	}
}